export const tokenCookieName = 'Abp.AuthToken';
